import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("g", {
        onPointerdown: [
            _cache[0] || (_cache[0] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.startDrag && _ctx.startDrag(...args)), ["left"])),
            _cache[1] || (_cache[1] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.rightclickCallback && _ctx.rightclickCallback(...args)), ["right", "exact"]))
        ],
        class: "anchor"
    }, [
        _createElementVNode("circle", {
            style: _normalizeStyle(_ctx.styles)
        }, null, 4)
    ], 32));
}
